import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-refuel]',
  template: `
    <td class="align-middle">
      <input type="checkbox" class="form-check-input form-check-input-lg border border-1 border-secondary me-2" (change)="selectRefuel($event)">
      {{refuel?.folio}}
    </td>
    <td class="align-middle">
      {{refuel?.tanque?.name}}
      <p class="mb-0" style="font-size: 13px;">{{refuel?.settlement?.name}} {{refuel?.building?.name}}</p>
    </td>
    <td class="align-middle text-center">{{refuel?.purchase_order?.liters}} Lts.</td>
    <td class="align-middle text-center">{{refuel?.liters}} Lts.</td>
    <td class="align-middle text-center">
      <span *ngIf="refuel?.price">{{refuel?.price | currency}}</span>
      <span *ngIf="!refuel?.price">-</span>
    </td>
    <td class="align-middle text-center">{{refuel?.purchase_order.created_at | date: 'dd/MM/yyyy'}}</td>
    <td class="align-middle text-center">{{refuel?.updated_at | date: 'dd/MM/yyyy HH:mm'}}</td>    
    <td>
      <button class="btn btn-link" routerLink="show/{{refuel.id}}">
        <fa-icon [icon]="icons.faEye" size="1x" class="center-icon"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrRefuelComponent {
  @Input() refuel: any;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() refuelSelected = new EventEmitter<any>();

  po: any = {};

  constructor(
    private store: SettlementsService,
    public icons: IconsService
  ) { }

  ngOnInit(): void {}

  selectRefuel(event: any) {
    this.refuelSelected.emit({ refuel: this.refuel, checked: event.target.checked});
  }
}
